export default function getDateFromDatePicker(
  event: {$d?: Date}[],
  props: [string, string] = ['fromCreatedAt', 'toCreatedAt']) {
  return {
    [props[0]]: event?.[0]?.$d?.toISOString(),
    [props[1]]: event?.[1]?.$d?.toISOString()
  };
}
